import Header from "Dashboard/components/Header";
import Toolbox from "./components/Toolbox";
import TopSection from "./components/TopSection";
import "../../../Stock/Index.scss";
import "../../styles/Index.scss";
import BottomSection from "./components/BottomSection";
import { IGetConcreteBaseInputsRequestParams } from "../../domain/IGetConcreteBaseInputsRequestParams";
import { useCallback, useEffect, useState } from "react";
import { getInputs } from "./inputSlice";
import { useAppDispatch } from "hooks/hooks";
import usePagingAndSort,
{ IGetPageRequestParams, IUpdateStateAfterSearchParams } from "hooks/pagingAndSort";
import { useForm } from "react-hook-form";

const Input = () => {
  const dispatch = useAppDispatch();

  const defaultGetInputsRequestParams: IGetConcreteBaseInputsRequestParams = {
    searchTerm: undefined,
  };

  const [getInputsRequestParams, setGetInputsRequestParams]
    = useState<IGetConcreteBaseInputsRequestParams>(defaultGetInputsRequestParams);

  const limit = 200;

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IGetConcreteBaseInputsRequestParams>({
    defaultValues: defaultGetInputsRequestParams
  });

  const getConcreteBaseInputsWithPaging = useCallback((
    pagingParams: IGetPageRequestParams,
    abortSignal: AbortSignal,
    updateStateAfterFetch: (updateStateParams: IUpdateStateAfterSearchParams) => void
  ): void => {
    dispatch(getInputs({
      getInputsRequestParams,
      pagingParams,
      abortSignal,
      updateStateAfterFetch
    }));
  }, [dispatch, getInputsRequestParams]);

  const { doSortBy, resetAfterSearch, lastElementRef, handleScroll }
    = usePagingAndSort(getConcreteBaseInputsWithPaging, limit);

  useEffect(() => {
    resetAfterSearch();
  }, [getInputsRequestParams]);

  return (
    <>
      <Header title="Betonska Baza" />
      <Toolbox
        defaultGetInputsRequestParams={defaultGetInputsRequestParams}
        setGetInputsRequestParams={setGetInputsRequestParams}
        registerSearch={registerSearch}
        handleSubmitSearch={handleSubmitSearch}
        resetSearch={resetSearch}
        controlSearch={controlSearch}
        getValuesSearch={getValuesSearch}
        setFocusSearch={setFocusSearch}
        setValueSearch={setValueSearch}
      />
      <main className="lager concreteBase">
        <TopSection
          lastTableElementRef={lastElementRef}
          handleScroll={handleScroll}
          doSortBy={doSortBy}
        />
        <BottomSection />
      </main>
    </>
  );
};

export default Input;
